import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import swal from 'sweetalert';
import App from './App';
import { history } from 'utils/hist';
import 'bootstrap/dist/css/bootstrap.min.css';
import setAuthToken from './utils/setAuthToken';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import isEmpty from 'validation/is-empty.js';
import jwt_decode from 'jwt-decode';
import store from './store';
import { logoutUser } from './redux/actions/authActions';

const MySwal = withReactContent(Swal);

const swalWithBootstrapButtons = MySwal.mixin({
  confirmButtonColor: '#2D5CA6',
  cancelButtonColor: '#FF0000',
  customClass: {
    confirmButton: 'br0 ',
    cancelButton: 'br0 mr-3'
  },
  buttonsStyling: true
});

axios.interceptors.request.use(
  function(response) {
    // console.log(response.headers)
    if (!isEmpty(response.headers.common['Authorization'])) {
      const token = response.headers.common['Authorization'];
      // console.log(token.substr(token.indexOf(" ") + 1))
      // const clearToken = token.substr(token.indexOf(' ') + 1);
      setAuthToken(token);

      const decoded = jwt_decode(token);

      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        MySwal.fire({
          title: 'Час сесії закінчився',
          //text: "Your session has expired. Would you like to be redirected to the login page?",
          //type: "warning",
          //showCancelButton: true,
          confirmButtonColor: '#2D5CA6',
          confirmButtonText: 'Ok',
          closeOnConfirm: false
        }).then(result => {
          // Logout user
          if (result.value) {
            store.dispatch(logoutUser());
            // Redirect to login
            //window.location.href = '/login';
            history.push('/login');
          }
        });
      }
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    // console.log(error.response.status);
    if (error.response.status === 400) {
      swalWithBootstrapButtons.fire({
        // title: 'Помилка',
        html: <pre className="text-danger bold h4">{error.response.data}</pre>,
        type: 'error'
      });
      return Promise.reject(error);
    } else if (error.response.status === 401) {
      swalWithBootstrapButtons
        .fire({
          title: 'Час сесії закінчився'
        })
        .then(result => {
          if (result.value) {
            history.push('/login');
          }
        });
      return Promise.reject(error);
    } else if (error.response.status === 500) {
      swalWithBootstrapButtons.fire({
        title: 'Вибачте, щось пішло не так',
        text: 'Ми працюємо над цим!',
        type: 'error'
      });
      // , function(){

      // });
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

ReactDOM.render(<App />, document.getElementById('root'));
